import React from "react";
import SectionCard from "../SectionCard/SectionCard";
import { ItensPoliticaCookies } from "../../constants/PoliticaCookiesItens";

function PoliticaCookies() {
  const subtext1 = (
    <p>
      Os <b>cookies são essenciais </b> para trazer um conteúdo personalizado
      para você, uma melhor apresentação dos nossos produtos e garantir um bom
      funcionamento do nosso site.
    </p>
  );
  return (
    <SectionCard
      id="Políticadecookies"
      title="Política de Cookies"
      subtext1={subtext1}
      itens={ItensPoliticaCookies}
    />
  );
}

export default PoliticaCookies;
